export enum SentryTeams {
    Accounts = 'Accounts',
    Admin = 'Admin',
    BookingEngine = 'BookingEngine',
    Connectivity = 'Connectivity',
    Data = 'Data',
    Distribution = 'Distribution',
    Finance = 'Finance',
    GuestPortal = 'GuestPortal',
    Infrastructure = 'Infrastructure',
    Internal = 'Internal',
    Merchant = 'Merchant',
    Productivity = 'Productivity',
    Reservations = 'Reservations',
    Tooling = 'Tooling',
}
